import { LegalLayout } from "@/components/LegalLayout";

export default function TermsOfService() {
  const sections = [
    {
      heading: "Acceptance of Terms",
      body: "By accessing or using ILFAL (\"the Platform\", \"we\", \"us\"), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you must not use the Platform. These terms apply to all visitors, registered users, and subscribers.",
    },
    {
      heading: "Description of Service",
      body: "ILFAL provides hands-on, interactive cybersecurity and AI-security training labs for educational purposes only. Access to certain labs and features requires a paid subscription. We reserve the right to modify, suspend, or discontinue any part of the service at any time.",
    },
    {
      heading: "Accounts and Registration",
      body: "You must provide accurate and complete information when creating an account and keep it up to date. You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account. You must be at least 18 years old, or the age of majority in your jurisdiction, to use the Platform.",
    },
    {
      heading: "Acceptable Use",
      body: "The Platform and its lab environments are provided strictly for lawful, educational use within the boundaries we provide. You agree not to:",
      list: [
        "Use any techniques, tools, or knowledge gained on the Platform against systems, networks, or accounts you do not own or lack explicit written permission to test.",
        "Attempt to attack, disrupt, or gain unauthorized access to ILFAL infrastructure, other users, or any system outside your assigned lab environment.",
        "Share, resell, or redistribute your account, subscription, lab content, or flags.",
        "Use the Platform to develop, host, or distribute malware or to conduct any illegal activity.",
      ],
    },
    {
      heading: "Subscriptions and Payments",
      body: "Paid subscriptions grant access to premium content for the billing period selected at checkout. Payments are processed by our third-party payment provider; by subscribing you also agree to their terms. Prices may change with reasonable notice. Refunds are governed by our Refund Policy.",
    },
    {
      heading: "Intellectual Property",
      body: "All content on the Platform — including lab scenarios, guides, code, text, graphics, and branding — is owned by ILFAL or its licensors and is protected by intellectual-property laws. You are granted a limited, non-exclusive, non-transferable license to access the content for personal educational use only.",
    },
    {
      heading: "Disclaimer of Warranties",
      body: "The Platform is provided \"as is\" and \"as available\" without warranties of any kind, whether express or implied. We do not warrant that the service will be uninterrupted, error-free, or secure. Educational content is provided for informational purposes and does not constitute professional security advice.",
    },
    {
      heading: "Limitation of Liability",
      body: "To the maximum extent permitted by law, ILFAL and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, revenue, or profits, arising out of or related to your use of the Platform. You are solely responsible for how you apply any knowledge gained.",
    },
    {
      heading: "Termination",
      body: "We may suspend or terminate your access at any time, without notice, for conduct that violates these terms or is otherwise harmful to the Platform or other users. Upon termination your right to use the Platform ceases immediately.",
    },
    {
      heading: "Changes to These Terms",
      body: "We may update these Terms of Service from time to time. Material changes will be communicated by posting the updated terms with a new \"Last updated\" date. Continued use of the Platform after changes take effect constitutes acceptance of the revised terms.",
    },
    {
      heading: "Contact",
      body: "For any questions regarding these terms, contact us at support@ilfal.com.",
    },
  ];

  return (
    <LegalLayout
      testid="terms-of-service-page"
      title="Terms of Service"
      updated="June 2026"
      intro="Please read these Terms of Service carefully before using ILFAL. They govern your access to and use of our platform and services."
      sections={sections}
    />
  );
}
